<template lang="pug">

  el-header(height="70px")#site-nav
    .page-width

      v-touch#logo.nav-item.pull-left(@tap="itemSelected('explore')") #[img(src="@/assets/logo-icon-white.png")]
      
      v-touch#menu.nav-item.link.text.pull-right.hide-sm-and-up(@tap="toggleMobileNav") Menu
      v-touch#back.nav-item.link.text.pull-left.hide-sm-and-up(v-if="$route.name === 'post'" @tap="$router.go(-1)") Back

      #nav-items(:class="{ 'active': displayMobileNav}")
        
        #nav-items-wrapper
          v-touch.nav-item.link.pull-left(@tap="itemSelected('explore')") Explore  
          v-touch.nav-item.link.pull-left(@tap="itemSelected('feed')") Feed
          v-touch.nav-item.link.pull-left(@tap="itemSelected('community')") Community
          a.nav-item.link.pull-left(href="http://localhost:2368/" target="_blank") Blog #[icon.margin-left(icon="external-link-square-alt")]
          //- v-touch.nav-item.link.pull-left(@tap="itemSelected('store')") Store #[icon.margin-left(icon="external-link-square-alt")]
          v-touch.nav-item.link.pull-right(@tap="showAuth()") Signup
          v-touch.nav-item.link.pull-right.highlight(@tap="showAuth()") Login
          .clearfix
        
        #nav-footer
          .footer-nav-item.pull-left About
          .footer-nav-item.pull-left Contact
          .footer-nav-item.pull-right Privacy
          .footer-nav-item.pull-right Terms
          .clearfix


</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SiteNav",
  data() {
    return {
      displayMobileNav: false
    };
  },
  watch: {
    $route() {
      this.displayMobileNav = false;
    }
  },
  computed: {
    ...mapGetters(["authVisible"])
  },
  methods: {
    showAuth() {
      this.$store.dispatch("setAuthVisible", true);
    },
    itemSelected(routeName) {
      this.displayMobileNav = false;
      this.$router.push({ name: routeName });
    },
    toggleMobileNav() {
      this.displayMobileNav = !this.displayMobileNav;
    }
  }
};
</script>

<style lang="stylus">
#site-nav {
  // animate();
  shadow();
  background-color: $color-nav;
  height: $nav-size;
  padding-left: 76px;
  padding-right: 0;
  position: fixed;
  bottom: auto;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;

  +tabletup() {
    padding-right: 10px;
  }

  +laptopup() {
    padding-left: 0px;

    #logo {
      position: relative !important;
    }
  }

  &:before {
    pinned(absolute);
    content: '';
    background-color: $color-nav;
    z-index: 0;
  }

  #menu {
    margin: 16px;
  }

  +tablet() {
    padding-left: 10px;
  }

  .page-width {
    margin: 0 auto;
    height: 70px;
    overflow: hidden;

    .nav-item {
      animate(background-color);
      color: white;
      font-weight: bold;
      font-size: 0.8em;
      line-height: 30px;
      margin: 16px 10px;
      padding: 4px 15px;
      position: relative;
      text-decoration: none;
      text-transform: uppercase;

      * {
        color: white;
      }

      &.highlight {
        background-color: $color-info !important;

        &:hover {
          background-color: lighten($color-info, 10%) !important;
        }
      }

      &.link {
        border-radius();

        &:hover {
          background-color: alpha(white, 0.2);
          cursor: pointer;
        }
      }

      &#logo {
        margin: 5px 0;
        padding: 5px 15px;
        pinned-tl(fixed);
        position: fixed;

        +tablet() {
          position: fixed;
          left: 50%;
          transform: translateX(-50%);
        }

        img {
          display: block;
          height: 50px;
          margin: 0;
          padding: 0;
          max-width: 50px;
        }
      }
    }
  }

  #nav-items {
    animate(top);
    position: relative;

    #nav-footer {
      pinned(fixed);
      // background-color: alpha(white, 0.05);
      border-top: alpha(white, 0.2) 1px solid;
      display: none;
      pointer-events: none;
      top: auto;
      height: 60px;
      margin: 0 auto;
      text-align: center;

      .footer-nav-item {
        color: white;
        font-size: 0.8em;
        font-weight: bold;
        line-height: 60px;
        padding: 0 15px;
      }
    }

    +tablet() {
      pinned(fixed);
      background-color: $color-nav;
      bottom: auto;
      top: $nav-size;
      min-height: 100vh;
      padding-bottom: 60px;
      z-index: -10;
      // opacity: 0;
      top: -100%;

      #nav-items-wrapper {
        animate(opacity);
        transition-delay: 0.1s;
        max-height: 80vh;
        overflow-y: auto;
        position: absolute;
        left: 50%;
        top: 80px;
        transform: translateX(-50%);
        // top: 50%;
        // transform: translate(-50%, -50%);
      }

      &.active {
        opacity: 1;
        top: 0;

        #nav-items-wrapper {
          opacity: 1;
        }

        #nav-footer {
          display: block;
          pointer-events: all;
        }
      }

      #nav-items-wrapper {
        opacity: 0;

        .nav-item {
          display: block;
          margin: 16px auto;
          float: none !important;
          max-width: calc(100% - 20px);
          width: 200px;
        }
      }
    }
  }
}
</style>
